import React, { useState } from 'react';
import SimulatorForm, { Option, Tag, SortableTagKeys } from './SimulatorForm';
import SimulatorResults from './SimulatorResults';
import SimulatorHeader from './SimulatorHeader';

export interface SimulationResultData {
  score: number;
  simulatedAmount: number | null;
  unit: string | null;
  range: string | null;
}

interface Props {
  type: string;
  tagSortKey: SortableTagKeys;
  presidentAgeOptions: Option[];
  birthOnOptions: Option[];
  businessTypeOptions: Option[];
  requestedFundingAmountOptions: Option[];
  totalFundingAmountOptions: Option[];
  currentValuationOptions: Option[];
  previousPeriodSalesOptions: Option[];
  financialStatusOptions: Option[];
  fundraisingSimulationTags: Tag[];
  onToggleAccordion?: () => void;
  onCloseAccordion?: () => void;
  isOpen?: boolean;
  disableAccordion?: boolean;
  headerVariant?: 'ecf' | 'plus' | 'about_company' | 'none';
}

const SimulatorView = (props: Props) => {
  // 初期値が必要なもののみconst定義
  const isOpen = props.isOpen ?? false;
  const disableAccordion = props.disableAccordion ?? false;
  const headerVariant = props.headerVariant ?? 'none';

  const [showResults, setShowResults] = useState(false);
  const [resultData, setResultData] = useState<SimulationResultData>({
    score: 0,
    simulatedAmount: null,
    unit: null,
    range: null,
  });

  const onShowResults = (simulationResults: SimulationResultData) => {
    setResultData(simulationResults);
    setShowResults(true);
  };

  const shouldShow = disableAccordion || isOpen;
  const showCloseButton = !disableAccordion && isOpen;
  const showStartOverlay = !disableAccordion && !isOpen;

  return (
    <div
      className={`simulator__block ${
        props.type === 'ecf' ? 'blue' : props.type === 'plus' ? 'black' : ''
      }`}
      onClick={!disableAccordion ? props.onToggleAccordion : undefined}
    >
      <SimulatorHeader variant={headerVariant} />

      <div
        className={`simulator__contents ${shouldShow ? '' : 'accordion-close'}`}
      >
        <SimulatorForm
          type={props.type}
          tagSortKey={props.tagSortKey}
          presidentAgeOptions={props.presidentAgeOptions}
          birthOnOptions={props.birthOnOptions}
          businessTypeOptions={props.businessTypeOptions}
          requestedFundingAmountOptions={props.requestedFundingAmountOptions}
          totalFundingAmountOptions={props.totalFundingAmountOptions}
          currentValuationOptions={props.currentValuationOptions}
          previousPeriodSalesOptions={props.previousPeriodSalesOptions}
          financialStatusOptions={props.financialStatusOptions}
          fundraisingSimulationTags={props.fundraisingSimulationTags}
          onShowResults={onShowResults}
        />

        {showResults && resultData && (
          <SimulatorResults type={props.type} resultData={resultData} />
        )}
        {showCloseButton && (
          <div className="simulator__contents__close">
            <span
              className="simulator__contents__close-btn"
              onClick={e => {
                e.stopPropagation();
                if (props.onCloseAccordion) {
                  props.onCloseAccordion();
                }
              }}
            >
              ×質問を閉じる
            </span>
          </div>
        )}
      </div>

      {showStartOverlay && (
        <div className="simulator__overlay">
          <div className="accordion-open">
            <div className="accordion-open-icon" />
            <div className="accordion-open-text">診断スタート</div>
          </div>
        </div>
      )}
    </div>
  );
};

const renderSimulatorView = (props: Props) => {
  return <SimulatorView {...props} />;
};

export default renderSimulatorView;
